import { render, staticRenderFns } from "./FormProducto.vue?vue&type=template&id=3d8d27c0&"
import script from "./FormProducto.vue?vue&type=script&lang=js&"
export * from "./FormProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports